import { FunctionComponent, memo } from "react";
import { useInteractionMetricConversion } from "hooks-for/metrics/use-interaction-metric-conversion";
import { InteractionMetric } from "@edgetier/watchtower-types";

import { BooleanIcon, DetailsFieldTitle, DetailsFieldValue } from "@edgetier/client-components";
import { IProps } from "./interaction-metrics-details.types";
import "./interaction-metrics-details.scss";

/**
 * Display formatted interaction metric including the unit
 * @param props.interactionMetric
 * @param props.value   Value of interaction metric
 */
const InteractionsMetricsDetails: FunctionComponent<IProps> = ({ interactionMetric, value }) => {
    const { metricLabel, unitShorthand, formatTick } = useInteractionMetricConversion(interactionMetric, {
        isAggregate: false,
        items: [value ?? 0],
        getValue: (value) => value,
    });

    const isBooleanInteractionMetric = interactionMetric === InteractionMetric.QueryResolution;

    return (
        <tr>
            <td>
                <DetailsFieldTitle>{metricLabel}</DetailsFieldTitle>
            </td>
            <td>
                <DetailsFieldValue copyText={value.toString()}>
                    {isBooleanInteractionMetric ? (
                        <BooleanIcon value={value} />
                    ) : (
                        <>
                            {formatTick(value)}
                            {unitShorthand}
                        </>
                    )}
                </DetailsFieldValue>
            </td>
        </tr>
    );
};

export default memo(InteractionsMetricsDetails);
